import React from "react";
import { Button } from "@mui/joy";
import { useSnapshot } from "valtio";
import "@mapbox/mapbox-gl-draw/dist/mapbox-gl-draw.css";
import { drawControlsStateManager } from "../../globals";

export const EditControls: React.FC = () => {
  const { drawControlsOpen } = useSnapshot(drawControlsStateManager.state);

  if (!drawControlsOpen) {
    return null;
  }

  return (
    <>
      <div
        style={{
          position: "absolute",
          bottom: "26px",
          right: "100px",
          width: "150px",
          zIndex: 3,
        }}
      >
        <div style={{ display: "flex", gap: "4px" }}>
          <Button size="sm" variant="soft">
            Save
          </Button>
          <Button size="sm" variant="soft">
            Delete
          </Button>
        </div>
        <div style={{ display: "flex", gap: "4px", marginTop: "4px" }}>
          <Button
            size="sm"
            variant="soft"
            color="neutral"
            onClick={() => {
              drawControlsStateManager.draw.changeMode("draw_point");
            }}
          >
            Point
          </Button>
          <Button
            size="sm"
            variant="soft"
            color="neutral"
            onClick={() => {
              drawControlsStateManager.draw.changeMode("draw_line_string");
            }}
          >
            Line
          </Button>
          <Button
            size="sm"
            variant="soft"
            color="neutral"
            onClick={() => {
              drawControlsStateManager.draw.changeMode("draw_polygon");
            }}
          >
            Polygon
          </Button>
        </div>
      </div>
    </>
  );
};
